export default __webpack_public_path__ + "static/media/reload.0ab3017b.svg";